module.exports = __webpack_public_path__ + "img/bipbip.dd0d87b1.png";